// frontend/src/pages/Profile/ChangePasswordModal.jsx
import React, { useState } from 'react';
import { useProfile } from '../contexts/ProfileContext';
import AlertMessage from '../components/ui/AlertMessage';
import './change-passwordmodal.scss';

const ChangePasswordModal = ({ isOpen, onClose }) => {
    const { changePassword, loading } = useProfile();
    const [formData, setFormData] = useState({
        current_password: '',
        new_password: '',
        confirm_password: ''
    });
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState(null);

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        // Clear error for this field
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const validate = () => {
        const newErrors = {};
        
        if (!formData.current_password) {
            newErrors.current_password = 'La password corrente è obbligatoria';
        }
        
        if (!formData.new_password) {
            newErrors.new_password = 'La nuova password è obbligatoria';
        } else if (formData.new_password.length < 6) {
            newErrors.new_password = 'La password deve avere almeno 6 caratteri';
        }
        
        if (formData.new_password !== formData.confirm_password) {
            newErrors.confirm_password = 'Le password non coincidono';
        }
        
        if (formData.current_password === formData.new_password) {
            newErrors.new_password = 'La nuova password deve essere diversa da quella corrente';
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validate()) return;
        
        const result = await changePassword({
            current_password: formData.current_password,
            new_password: formData.new_password
        });
        
        if (result.success) {
            setMessage({ type: 'success', text: result.message });
            setTimeout(() => {
                onClose();
                setFormData({ current_password: '', new_password: '', confirm_password: '' });
                setMessage(null);
            }, 2000);
        } else {
            setMessage({ type: 'error', text: result.error });
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>🔒 Cambia Password</h3>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>

                <form onSubmit={handleSubmit}>
                    {message && <AlertMessage type={message.type} message={message.text} />}

                    <div className="form-group">
                        <label>Password Corrente</label>
                        <input
                            type="password"
                            name="current_password"
                            value={formData.current_password}
                            onChange={handleChange}
                            placeholder="Inserisci la password corrente"
                        />
                        {errors.current_password && 
                            <span className="error">{errors.current_password}</span>
                        }
                    </div>

                    <div className="form-group">
                        <label>Nuova Password</label>
                        <input
                            type="password"
                            name="new_password"
                            value={formData.new_password}
                            onChange={handleChange}
                            placeholder="Minimo 6 caratteri"
                        />
                        {errors.new_password && 
                            <span className="error">{errors.new_password}</span>
                        }
                    </div>

                    <div className="form-group">
                        <label>Conferma Nuova Password</label>
                        <input
                            type="password"
                            name="confirm_password"
                            value={formData.confirm_password}
                            onChange={handleChange}
                            placeholder="Ripeti la nuova password"
                        />
                        {errors.confirm_password && 
                            <span className="error">{errors.confirm_password}</span>
                        }
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn-cancel" onClick={onClose}>
                            Annulla
                        </button>
                        <button type="submit" className="btn-save" disabled={loading}>
                            {loading ? 'Aggiornamento...' : 'Aggiorna Password'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChangePasswordModal;
